import { NonF2fMedicalCategory } from '@/types/bff/gql-schema';
import useMedicalCategoryDisplayViewModel from '../hooks/useMedicalCategoryDisplayViewModel';
import { MEDICAL_CATEGORY_CONFIG } from '../lib/constants';
import CategoryGrid from './CategoryGrid';
import CategoryItem from './CategoryItem';

const MedicalCategoryGrid = () => {
  const { medicalCategories, isLoading, getCategoryPath } = useMedicalCategoryDisplayViewModel(
    MEDICAL_CATEGORY_CONFIG.DEFAULT_DISPLAY_SIZE
  );

  return (
    <CategoryGrid isLoading={isLoading}>
      {medicalCategories.map((category) => (
        <CategoryItem
          key={category.id}
          category={category}
          categoryPath={getCategoryPath(category as NonF2fMedicalCategory)}
        />
      ))}
    </CategoryGrid>
  );
};

export default MedicalCategoryGrid;
